// ═══════════════════════════════════════
// WFC THEME – Main JavaScript
// ═══════════════════════════════════════

document.documentElement.classList.remove('no-js');

// ── MOBILE MENU ──────────────────────
const burger = document.getElementById('wfc-burger');
const mobileNav = document.getElementById('wfc-mobile-nav');
const mobileClose = document.getElementById('wfc-mobile-close');

if (burger && mobileNav) {
  burger.addEventListener('click', () => {
    mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}
if (mobileClose && mobileNav) {
  mobileClose.addEventListener('click', () => {
    mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  });
}

// ── CART COUNT UPDATE ─────────────────
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.wfc-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(() => {});
}
updateCartCount();

// ── AJAX ADD TO CART ──────────────────
document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form.matches('[action="/cart/add"]')) return;
  e.preventDefault();

  const btn = form.querySelector('[type="submit"]');
  if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }

  const data = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', body: data })
    .then(r => r.json())
    .then(() => {
      updateCartCount();
      const notif = document.getElementById('cart-notification');
      if (notif) {
        notif.removeAttribute('aria-hidden');
        setTimeout(() => notif.setAttribute('aria-hidden', 'true'), 4000);
      }
      if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; }
    })
    .catch(() => {
      if (btn) { btn.disabled = false; btn.textContent = 'Fehler – bitte erneut versuchen'; }
    });
});

// ── COLLECTION FILTER TAGS ────────────
document.querySelectorAll('.wfc-filter-tag[data-tag]').forEach(tag => {
  tag.addEventListener('click', () => {
    const current = new URL(window.location.href);
    const tagVal = tag.dataset.tag;
    if (tagVal === '') {
      current.search = '';
    } else {
      current.searchParams.set('filter.p.tag', tagVal);
    }
    window.location.href = current.toString();
  });
});

// ── QUANTITY BUTTONS ──────────────────
document.addEventListener('click', function(e) {
  if (e.target.matches('.wfc-qty-minus')) {
    const input = e.target.nextElementSibling;
    if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
  }
  if (e.target.matches('.wfc-qty-plus')) {
    const input = e.target.previousElementSibling;
    if (input) input.value = parseInt(input.value) + 1;
  }
});

// ── ANNOUNCEMENT BAR CLOSE ────────────
const annClose = document.getElementById('ann-close');
if (annClose) {
  annClose.addEventListener('click', () => {
    const bar = document.querySelector('.announcement-bar');
    if (bar) bar.style.display = 'none';
  });
}
